import { useOrderManagementStore } from "@/scenes/OrderManagement/store/OrderManagementStore";
import { Button } from "antd";
import { observer } from "mobx-react-lite";
import React, { useEffect, useState } from "react";

interface LogisticsAgingPredictColumnProps {
    orderId: number;
}

const LogisticsAgingPredictColumn: React.FC<LogisticsAgingPredictColumnProps> = function (props) {
    const { orderId } = props;
    const { storage } = useOrderManagementStore();
    const [showAll, setShowAll] = useState(false);

    useEffect(() => {
        setShowAll(false);
    }, [orderId]);

    if (storage.logisticsAgingPredictLoading) {
        return (
            <td className="tc">
                <span>加载中</span>
            </td>
        );
    }

    const logisticsAgingPredictResult = storage.logisticsAgingPredictMapping.get(orderId);

    if (!logisticsAgingPredictResult) return <td></td>;

    const simpleRes = showAll ? logisticsAgingPredictResult.results : logisticsAgingPredictResult.results.slice(0, 3);

    return (
        <td>
            {simpleRes.map((res) => {
                return (
                    <p key={res} style={{ margin: "3px 0" }}>
                        {res}
                    </p>
                );
            })}

            {simpleRes.length ? (
                <Button
                    type="link"
                    onClick={() => {
                        setShowAll(!showAll);
                    }}
                >
                    {showAll ? "收起" : "显示更多..."}
                </Button>
            ) : null}
        </td>
    );
};

export default observer(LogisticsAgingPredictColumn);
